// @ts-strict-ignore
import type { Dispatch, MutableRefObject, SetStateAction } from 'react';
import type { MultiSelectProps } from '@usealloy/component-library';
import { createContext } from 'react';
import type { AggregationSourceData } from './types';
import type { Attribute } from 'flow/store/engine/types';
import { AggregationEditorOrigin } from '../NodeEditorDrawer/types';

export type AggregationEditorContextType = {
  sourceData: AggregationSourceData;
  setSourceData: Dispatch<SetStateAction<AggregationSourceData>>;
  handleClose: () => void;
  /** Ref for the aggregation editor root container; used for keyboard focus scope (mirrors MLA mlaEditorPanelBoxContainerRef). */
  aggregationEditorContainerRef: MutableRefObject<HTMLDivElement | null>;
  /** Which editor surface opened this aggregation editor (threshold left, right, or data route). */
  origin: AggregationEditorOrigin;
  /** Resolved attribute for the active threshold side. */
  attribute: Attribute | null;
  /** Shared MultiSelect presentation props (preview state, disabled state, etc.). */
  multiSelectProps: Partial<MultiSelectProps>;
};

export const AggregationEditorContext = createContext<AggregationEditorContextType>({
  sourceData: {} as AggregationSourceData,
  setSourceData: () => {},
  handleClose: () => {},
  aggregationEditorContainerRef: { current: null },
  origin: AggregationEditorOrigin.THRESHOLD_LEFT,
  attribute: null,
  multiSelectProps: {},
});
